<template>
  <layout-public>
    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col md="4" offset-md="4">
          <v-content>
            <v-card class="elevation-12" fill-height>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Your trial account is ready</v-toolbar-title>
              </v-toolbar>
              <!-- Nothing is emailed at signup (RegisterUserAction sends no
                   mail), so this page must not say "check your inbox". The
                   email arrives with the login page prefilled. -->
              <v-card-text class="thankyou-body">
                <p>
                  Thanks for signing up<template v-if="email">, <strong>{{ email }}</strong></template>.
                  Your 14 day trial is set up. Log in with the email and password
                  you just chose to get started.
                </p>
                <v-btn
                  color="primary"
                  depressed
                  large
                  block
                  class="thankyou-login"
                  :to="loginRoute"
                >
                  Log in to IMPROVE
                </v-btn>
              </v-card-text>
            </v-card>
          </v-content>
        </v-col>
      </v-row>
    </v-container>
  </layout-public>
</template>
<script>
import LayoutPublic from '@/layouts/Public';
export default {
  name: 'Thankyou',
  components: {
    LayoutPublic,
  },
  computed: {
    email() {
      return (this.$route.query && this.$route.query.email) || '';
    },
    loginRoute() {
      return this.email ? { path: '/login', query: { email: this.email } } : { path: '/login' };
    },
  },
};
</script>

<style scoped>
.thankyou-body p {
  font-size: 15px;
  line-height: 1.55;
  margin-bottom: 18px;
}

.thankyou-login {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
}
</style>
